import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { Link } from "react-router-dom";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";

function OthersAccountProfile({ allowedRoles }) {
    const { allowLoading } = useAuthentication(allowedRoles)

    const [loading, setLoading] = useState();
    const [buildingData, setBuildingData] = useState([]);
    const [buildingSearch, setSearchBuilding] = useState("");
    const [record, setRecord] = useState(5);
    const [pages, setPages] = useState(1);
    const [pageNumberlimit, setPageNumberlimit] = useState(1);
    const [maxPageNumberlimit, setMaxPageNumberlimit] = useState(4);
    const [minPageNumberlimit, setMinPageNumberlimit] = useState(0);
    const [totallength, setTotallength] = useState([]);
    const [Count, setCount] = useState();
    const { designation } = useAuth();
    const [isKeyPress, setisKeyPress] = useState(false);
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
    useEffect(() => {
        // BuildingDataList();
        if (buildingSearch && record && pages) {
            SearchBuilding();
        } else {
            BuildingDataList();
        }
    }, [buildingSearch, record, pages]);
 
    const BuildingDataList = () => {
        setLoading(true);

        axiosFetch({
          axiosInstance: axios,
          method: "POST",
          url: "accountant/Collection/cash/list",
          requestConfig: {
            record,
            pages,
          },
        })
            .then((response) => {

                if (response?.data?.result?.count >= 0) {
                 
                    setCount(response?.data?.result?.count);
                    setBuildingData(response.data.result.rows);
                }
                if (response?.data?.totallength >= 0) {
                    let pageNo = response.data.totallength;
                    let pagelist = [];
                    for (let i = 0; i < pageNo; i++) {
                        pagelist.push(i + 1);
                    }
                    setTotallength(pagelist);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const SearchBuilding = () => {
        !isKeyPress && setPages(1);
        axios
            .post(`/search`, {
                buliding_name: buildingSearch,
                record: record,
                page: isKeyPress ? pages : 1,
            })
            .then((res) => {
                if (res?.data) {
                    setBuildingData(res?.data?.result?.rows);
                }
                setCount(res?.data?.result?.count);
                if (res?.data?.totallength >= 0) {
                    let pageNo = res.data.totallength;
                    let pagelist = [];
                    for (let i = 0; i < pageNo; i++) {
                        pagelist.push(i + 1);
                    }
                    setTotallength(pagelist);
                }
            });
    };

    const PagesFunc = (val) => {
        setisKeyPress(true);
        setPages(val);
    };
    function handleNextbtn() {
        setisKeyPress(true);
        setPages(pages + 1);
        if (pages + 1 > maxPageNumberlimit) {
            setMaxPageNumberlimit(maxPageNumberlimit + pageNumberlimit);
            setMinPageNumberlimit(minPageNumberlimit + pageNumberlimit);
        }
    }

    function handlePrevbtn() {
        setisKeyPress(true);
        setPages(pages - 1);
        if ((pages - 1) % pageNumberlimit == 0) {
            setMaxPageNumberlimit(maxPageNumberlimit - pageNumberlimit);
            setMinPageNumberlimit(minPageNumberlimit - pageNumberlimit);
        }
    }

    const PageShowFunc = totallength?.map((items, i) => {
        if (items) {
            return (
                <li key={i}>
                    <button
                        value={items}
                        name="pages"
                        className={pages == items ? "active" : null}
                        onClick={(e) => PagesFunc(items)}
                    >
                        {items}
                    </button>
                </li>
            );
        } else {
            return null;
        }
    });

    return (
        <>
            <DashboardLayouts>
                {(loading || allowLoading) && <Loader />}

                <div className="breadcrumb row justify-content-between align-items-center">
                    <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
                        <Link
                            to={
                                designation === "Owner" || designation === "Partner"
                                    ? "/dashboard"
                                    : `/${designation}dashboard`.toLowerCase()
                            }
                            className="d-flex align-items-center back-link"
                        >
                            <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
                            <i className="icon-dashboard"></i>
                            <h3 className="mb-0 fw-normal">Dashboard</h3>
                        </Link>
                    </div>
                </div>
                {/* ----- Body Content ---- */}
                <div className="list-data">
                    <h1 className="heading-text mb-4">View All Collection</h1>
                    {/* --- Data filter --- */}
                    <div className="data-filters d-flex justify-content-between align-items-center mb-4">
                        <div className="page-records d-flex align-items-center">
                            <form action="" className="number">
                                <select
                                    className="number-box"
                                    value={record}
                                    name="record"
                                    onChange={(event) => {
                                        setRecord(event.target.value);
                                        setPages(1);
                                    }}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                            </form>
                            <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
                        </div>

                        {/* <div className="form search-bar1">
                            <input
                                type="search"
                                className="form-control search-new"
                                placeholder="search option name"
                                aria-label="search"
                                aria-describedby="search"
                                name="buildingSearch"
                                value={buildingSearch}
                                onKeyDown={(e) => setisKeyPress(false)}
                                onChange={(e) => setSearchBuilding(e.target.value.trimStart())}
                            />
                            <button
                                className="search-btn fa-solid fa-magnifying-glass"
                                type="submit"
                                disabled={buildingSearch.trimStart() == ""}
                                onClick={(e) => SearchBuilding(e)}
                            >
                                <FaSearch className="m-0 " color="#bebebe" />
                            </button>
                        </div> */}
                    </div>
                </div>
                <div className="w-100 table-content overflow-auto">
                    <table className="w-100">
                        <thead>
                            <tr>
                                <th className="text-center">Sl No.</th>
                                <th className="text-center">Date </th>
                                <th className="text-center"> Name</th>
                                {/* <th className="text-center">Designation</th> */}
                                <th className="text-center">Collected Amount </th>
                                <th className="text-center">Deposit to Bank</th>
                                <th className="text-center">Balance Cash</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {buildingData?.length > 0 ? (
                                buildingData?.map((items, i) =>{
                                    return(
                                        <tr>
                                            <td className="text-center">
                                                {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                                            </td>
                                            <td className="text-center">
                                                {moment(items.date).format("L")}
                                            </td>
                                            <td className="text-center">
                                                {items.name}
                                            </td>
                                            <td className="text-center">
                                                {items.Collected_Amount}    
                                            </td>
                                            <td className="text-center">
                                                {items.Deposit_to_bank}
                                            </td>
                                            <td className="text-center">
                                                {items.Balance_cash}
                                            </td>
                                            <td>
                                                <ul className="table-icon d-flex justify-content-center align-items-center">
                                                    <li>
                                                        <Link to={designation == "Owner" ? `/owner/miscellaneous/collection/${items.id}` : `/accountant/miscellaneous/collection/${items.id}`}
                                                            >
                                                        <FaEye className="view-icon" color="black" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )
                                })
                            ):( 
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {Count > 5 && totallength.length > 1 ? (
                    <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
                        <button
                            onClick={handlePrevbtn}
                            disabled={pages == 1 ? true : false}
                        >
                            <GrFormPrevious className="pagebutton" color="#bebebe" />
                        </button>
                        <ul className="d-flex">
                            {buildingData.length > 0 && PageShowFunc}
                        </ul>
                        <button
                            onClick={handleNextbtn}
                            disabled={pages == PageShowFunc.length ? true : false}
                        >
                            <GrFormNext className="pagebutton" color="#bebebe" />
                        </button>
                    </div>
                ) : null}
            </DashboardLayouts>
        </>
    );
}

export default OthersAccountProfile;
